<template>
  <DefaultLayout>
    <div slot="content">
      <!-- FEATURE LIMITED DIALOG-->
      <v-dialog v-model="featureLimitedModal" width="400" persistent>
        <v-card>
          <v-card-title>Feature limited</v-card-title>
          <v-card-text>{{ featureLimitedText || featureLimitedDefaultText }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="featureLimitedModal = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- GENERATED PDF TERM AND CONDITIONS DIALOG -->
      <v-dialog v-model="pdfView" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card height="100%" class="d-flex flex-column">
          <v-card-title
            >{{ pdfName }}
            <v-spacer></v-spacer>
            <v-btn @click="closeTermsPdfDialog" text icon><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-0" style="height: 100%">
            <iframe :src="pdfData" height="100%" width="100%"></iframe>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- END FEATURE LIMITED DIALOG-->
      <v-tabs
        slider-color="black"
        active-class="v-tabs_active_item"
        v-model="orgSettingsTabs"
        show-arrows
      >
        <v-tab class="font-weight-bold" :ripple="false">General settings</v-tab>
        <v-tab class="font-weight-bold" :ripple="false">Users</v-tab>
        <v-tab class="font-weight-bold" :ripple="false">Custom reasons for declining</v-tab>
        <v-tab class="font-weight-bold" :ripple="false">Terms / agreements</v-tab>
        <v-tab class="font-weight-bold" :ripple="false"
          >Custom reasons for document rejection</v-tab
        >
        <v-tab class="font-weight-bold" :ripple="false">WebHooks</v-tab>
        <v-tab class="font-weight-bold" :ripple="false">Privacy Audit</v-tab>
        <v-tab class="font-weight-bold" :ripple="false">Branding</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="orgSettingsTabs">
        <!-- GENERAL SETTINGS TAB -->
        <v-tab-item>
          <v-form ref="settingsForm" class="mb-5">
            <v-row>
              <v-col cols="12" sm="12" md="8">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      required
                      v-model="accountName"
                      label="Account Name"
                      type="text"
                      ref="accountName"
                      :rules="[(v) => !!v || 'Please enter account name']"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2">Active</v-col>
                  <v-col cols="12" sm="6">
                    <v-switch class="mt-0" hide-details v-model="isActive"></v-switch>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 .body-2"
                    >Allow purging of requests that have not been downloaded</v-col
                  >
                  <v-col cols="12" sm="6">
                    <v-switch
                      class="mt-0"
                      hide-details
                      v-model="allowPurgeWithoutDownload"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2"
                    >Enable custom reasons for declining request</v-col
                  >
                  <v-col cols="12" sm="6">
                    <v-switch
                      class="mt-0"
                      hide-details
                      v-model="enableCustomDeclinedReason"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2"
                    >Allow users to create custom reasons for declining</v-col
                  >
                  <v-col cols="12" sm="6">
                    <v-switch
                      class="mt-0"
                      hide-details
                      v-model="allowOtherDeclinedReasons"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2"
                    >Enable custom reasons for document rejection</v-col
                  >
                  <v-col cols="12" sm="6">
                    <v-switch
                      class="mt-0"
                      hide-details
                      v-model="enableCustomRejectedDocumentReason"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2"
                    >Delete documents when rejected</v-col
                  >
                  <v-col cols="12" sm="6">
                    <v-switch class="mt-0" hide-details v-model="rejectedDocumentAction"></v-switch>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2"
                    >Notification when user starts data request</v-col
                  >
                  <v-col cols="12" sm="6">
                    <v-switch
                      class="mt-0"
                      hide-details
                      v-model="suppressStartRequestEmail"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2"
                    >Turn off notification when user completes data request</v-col
                  >
                  <v-col cols="12" sm="6">
                    <v-switch
                      class="mt-0"
                      hide-details
                      v-model="suppressFinishRequestEmail"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-btn
              tile
              depressed
              color="blue white--text"
              :loading="loading"
              @click="saveSettings"
              class="mr-2"
              >Save Settings</v-btn
            >
            <!-- <v-btn small tile depressed color="red white--text" :disabled="account.default" @click="removeAccount">Remove Account</v-btn> -->
          </v-form>
        </v-tab-item>
        <!-- END GENERAL SETTINGS TAB -->
        <!-- USERS TAB -->
        <v-tab-item>
          <div class="d-flex align-center py-4">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="userSearch"
              append-icon="search"
              label="Search"
              hide-details
              dense
            ></v-text-field>
            <v-btn
              id="add-user"
              small
              tile
              depressed
              color="blue white--text"
              class="ml-4"
              @click="addUser"
              >Add user</v-btn
            >
            <v-spacer></v-spacer>
          </div>
          <v-data-table
            v-if="account.users"
            :headers="userHeaders"
            :loading="userDataLoading"
            :items="account.users"
            :search="userSearch"
            :footer-props="{
              itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
              showFirstLastPage: false,
              prevIcon: 'fal fa-chevron-left',
              nextIcon: 'fal fa-chevron-right',
              itemsPerPageText: 'Users per page'
            }"
            :hide-default-footer="account.users && account.users.length < 11"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
                :showFirstLastPage="false"
                prevIcon="fal fa-chevron-left"
                nextIcon="fal fa-chevron-right"
                @update:options="updateOptions"
                items-per-page-text="Users per page"
              />
            </template>
            <template v-slot:item.name="{ item }">
              {{ item.firstName + ' ' + item.lastName }}
            </template>
            <template v-slot:item.id="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="green" @click="editUser(item)"
                    ><v-icon>edit</v-icon></v-btn
                  >
                </template>
                <span>Edit User</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="orange" @click="resendInvite(item)"
                    ><v-icon>email</v-icon></v-btn
                  >
                </template>
                <span>Resend invite link</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="red" @click="removeUser(item)"
                    ><v-icon>clear</v-icon></v-btn
                  >
                </template>
                <span>Remove User</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-tab-item>
        <!-- END USERS TAB -->
        <!-- CUSTOM REASONS FOR DECLINING REQUEST TAB -->
        <v-tab-item>
          <div class="d-flex align-center py-4">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="filterReason"
              append-icon="search"
              label="Search"
              hide-details
              dense
            ></v-text-field>
            <v-btn small tile depressed color="blue white--text" class="ml-4" @click="addReason"
              >Add new</v-btn
            >
            <v-spacer></v-spacer>
          </div>
          <v-data-table
            v-if="account.declinedReasons"
            :headers="declinedReasonsHeaders"
            :items="account.declinedReasons"
            :search="filterReason"
            :footer-props="{
              itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
              showFirstLastPage: false,
              prevIcon: 'fal fa-chevron-left',
              nextIcon: 'fal fa-chevron-right',
              itemsPerPageText: 'Reasons per page'
            }"
            :hide-default-footer="account.declinedReasons && account.declinedReasons.length < 11"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
                :showFirstLastPage="false"
                prevIcon="fal fa-chevron-left"
                nextIcon="fal fa-chevron-right"
                @update:options="updateOptions"
                items-per-page-text="Reasons per page"
              />
            </template>
            <template v-slot:item.includeInEmail="{ item }">
              {{ item.includeInEmail ? 'Yes' : 'No' }}
            </template>
            <template v-slot:item.id="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="green" @click="editReason(item)"
                    ><v-icon>edit</v-icon></v-btn
                  >
                </template>
                <span>Edit Reason</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="red" @click="removeReason(item)"
                    ><v-icon>clear</v-icon></v-btn
                  >
                </template>
                <span>Remove Reason</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-tab-item>
        <!-- END CUSTOM REASONS FOR DECLINING REQUEST TAB -->
        <!-- TERMS/AGREEMENTS TAB -->
        <v-tab-item>
          <div class="d-flex align-center py-4">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="filterTerm"
              append-icon="search"
              label="Search"
              hide-details
              dense
            ></v-text-field>
            <v-btn small tile depressed color="blue white--text" class="ml-4" @click="addTerm"
              >Add new</v-btn
            >
            <v-spacer></v-spacer>
          </div>
          <v-data-table
            v-if="account.terms"
            :headers="agreementsHeaders"
            :items="account.terms.filter((it) => it.deleted === false)"
            :search="filterTerm"
            :footer-props="{
              itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
              showFirstLastPage: false,
              prevIcon: 'fal fa-chevron-left',
              nextIcon: 'fal fa-chevron-right',
              itemsPerPageText: 'Terms per page2'
            }"
            :hide-default-footer="account.terms && account.terms.length < 11"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
                :showFirstLastPage="false"
                prevIcon="fal fa-chevron-left"
                nextIcon="fal fa-chevron-right"
                @update:options="updateOptions"
                items-per-page-text="Terms per page1"
              />
            </template>
            <template v-slot:item.name="{ item }">
              <a target="_blank" @click="downloadAndSaveFile(item.url, item.name)">{{
                item.name
              }}</a>
            </template>
            <template v-slot:item.id="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="red" @click="removeTerm(item)"
                    ><v-icon>clear</v-icon></v-btn
                  >
                </template>
                <span>Remove</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-tab-item>
        <!-- END TERMS/AGREEMENTS TAB -->
        <!-- CUSTOM REJECTION REASONS TAB -->
        <v-tab-item>
          <div class="d-flex align-center py-4">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="rejectFilter"
              append-icon="search"
              label="Search"
              hide-details
              dense
            ></v-text-field>
            <v-btn small tile depressed color="blue white--text" class="ml-4" @click="addReject"
              >Add new</v-btn
            >
            <v-spacer></v-spacer>
          </div>
          <v-data-table
            v-if="account.rejectDocumentReasons"
            :headers="rejectHeaders"
            :items="account.rejectDocumentReasons"
            :search="rejectFilter"
            :footer-props="{
              itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
              showFirstLastPage: false,
              prevIcon: 'fal fa-chevron-left',
              nextIcon: 'fal fa-chevron-right',
              itemsPerPageText: 'Reasons per page'
            }"
            :hide-default-footer="
              account.rejectDocumentReasons && account.rejectDocumentReasons.length < 11
            "
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
                :showFirstLastPage="false"
                prevIcon="fal fa-chevron-left"
                nextIcon="fal fa-chevron-right"
                @update:options="updateOptions"
                items-per-page-text="Reasons per page"
              />
            </template>
            <template v-slot:item.id="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="red" @click="removeReject(item)"
                    ><v-icon>clear</v-icon></v-btn
                  >
                </template>
                <span>Remove</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-tab-item>
        <!-- END CUSTOM REJECTION REASONS TAB -->
        <!-- WEBHOOKS TAB -->
        <v-tab-item>
          <div class="d-flex align-center py-4">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="webhookFilter"
              append-icon="search"
              label="Search"
              hide-details
              dense
            ></v-text-field>
            <v-btn
              small
              tile
              depressed
              color="blue white--text"
              class="ml-4"
              @click="webhookModal = true"
              >Add new</v-btn
            >
            <v-spacer></v-spacer>
          </div>
          <v-data-table
            v-if="account.webHookEndpoints"
            :headers="webhookHeaders"
            :items="account.webHookEndpoints"
            :search="webhookFilter"
            :footer-props="{
              itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
              showFirstLastPage: false,
              prevIcon: 'fal fa-chevron-left',
              nextIcon: 'fal fa-chevron-right',
              itemsPerPageText: 'Webhooks per page'
            }"
            :hide-default-footer="account.webHookEndpoints && account.webHookEndpoints.length < 11"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
                :showFirstLastPage="false"
                prevIcon="fal fa-chevron-left"
                nextIcon="fal fa-chevron-right"
                @update:options="updateOptions"
                items-per-page-text="Webhooks per page"
              />
            </template>
            <template v-slot:item.id="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text icon color="red" @click="removeWebhook(item)"
                    ><v-icon>clear</v-icon></v-btn
                  >
                </template>
                <span>Remove</span>
              </v-tooltip>
            </template>
            <template v-slot:item.typeString="{ item }">
              <div v-if="item.typeString === 'GBGVerifications'">PVVerifications</div>
              <div v-else>{{ getWebHookType(item.type) }}</div>
            </template>
          </v-data-table>
        </v-tab-item>
        <!-- END WEBHOOKS TAB -->
        <!-- PRIVACY AUDIT -->
        <v-tab-item>
          <v-card
            max-width="960"
            elevation="0"
            class="mt-4"
            v-if="$store.getters.isSummaryRequestCreator"
          >
            <v-card-title>Share profile privacy audit</v-card-title>
            <v-card-text>
              <p class="font-weight-light body-2">
                Use the profile privacy audit to receive a report via email to indicate what kind of
                information is on currently record for a given profile, or has been collected and
                purged in the past.
              </p>
              <v-form ref="privacyForm">
                <v-text-field
                  required
                  v-model="privacyEmail"
                  label="Enter profile email address"
                  type="email"
                  :rules="[validateRequiredRule, validateEmailRule]"
                  :error-messages="emailErrors"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn tile depressed dark color="blue" @click="createPrivacyAudit"
                >Request audit</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <!-- END PRIVACY AUDIT -->
        <!-- BRANDING -->
        <v-tab-item>
          <v-card
            max-width="960"
            elevation="0"
            class="mt-4"
            v-if="$store.getters.isSummaryRequestCreator"
          >
            <v-card-title>Add Logo</v-card-title>
            <v-card-text>
              <p class="font-weight-light body-2">
                Utilize this logo to personalize guest requests.
              </p>
              <h3 class="title black--text mb-2">Logo requirements</h3>
              <ul class="requirements-list">
                <li
                  v-for="item in logoRequirements"
                  :key="item.label"
                  class="font-weight-light body-2"
                >
                  <b class="black--text">{{ item.label }}</b> {{ item.description }}
                </li>
              </ul>

              <v-form ref="newItemForm">
                <v-file-input
                  v-model="logo"
                  placeholder="Select Logo"
                  label="Logo file"
                  multiple
                  show-size
                  prepend-icon="fas fa-file-upload"
                >
                  <template v-slot:selection="{ text }">
                    <v-chip small label color="primary">
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn tile depressed dark color="blue" @click="addLogo" :loading="createInProgress"
                >Add Logo</v-btn
              >
            </v-card-actions>
            <v-card-text v-if="account.logo">
              <h3 class="title black--text mb-2">Your currently downloaded Logo</h3>
              <v-img max-width="300" contain :src="account.logo"></v-img>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!--END BRANDING -->
      </v-tabs-items>

      <!-- ADD/EDIT USER DIALOG -->
      <v-dialog v-model="userModal" width="400">
        <v-card>
          <v-card-title>{{ userModalTitle }}</v-card-title>
          <v-card-text>
            <v-form ref="userForm">
              <v-text-field
                id="add-user-first-name"
                :disabled="userEdit"
                required
                v-model="userFirstName"
                label="First Name"
                type="text"
                ref="userFirstName"
                :rules="[() => !!userFirstName || '']"
              ></v-text-field>
              <v-text-field
                id="add-user-last-name"
                :disabled="userEdit"
                required
                v-model="userLastName"
                label="Last Name"
                type="text"
                ref="userLastName"
                :rules="[() => !!userLastName || '']"
              ></v-text-field>
              <v-text-field
                id="add-user-email"
                :disabled="userEdit"
                required
                v-model="userEmail"
                label="Email"
                type="text"
                ref="userEmail"
                :rules="[() => !!userEmail || '']"
              ></v-text-field>
              <v-select
                id="add-user-role"
                dense
                multiple
                :items="systemRoles"
                v-model="userSelectedRoles"
                label="Select Role"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item }}</span>
                  <span v-if="index === 1" class="ml-1 grey--text caption"
                    >(+{{ userSelectedRoles.length - 1 }} others)</span
                  >
                </template>
              </v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text tile color="blue" @click="userModal = false">Close</v-btn>
            <v-btn id="add-user-save" dark tile depressed color="blue" @click="saveUser"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END ADD/EDIT USER DIALOG -->
      <!-- ADD/EDIT DECLINED REASON DIALOG -->
      <v-dialog v-model="reasonModal" width="400">
        <v-card>
          <v-card-title>{{ declinedReasonTitle }}</v-card-title>
          <v-card-text>
            <v-form ref="reasonForm">
              <v-text-field
                required
                v-model="reasonName"
                label="Name"
                type="text"
                ref="reasonName"
                :rules="[() => !!reasonName || '']"
              ></v-text-field>
              <v-text-field
                required
                v-model="reasonDescription"
                label="Description"
                type="text"
                ref="reasonDescription"
                :rules="[() => !!reasonDescription || '']"
              ></v-text-field>
              <v-switch
                class="mt-0"
                label="Include In Email"
                v-model="reasonIncludeInEmail"
              ></v-switch>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text tile color="blue" @click="reasonModal = false">Close</v-btn>
            <v-btn dark tile depressed color="blue" @click="saveDeclinedReason">{{
              reasonEdit ? 'Save' : 'Add'
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END ADD/EDIT DECLINED REASON DIALOG -->
      <!-- ADD TERMS/AGREEMENT DIALOG -->
      <v-dialog v-model="termModal" width="480">
        <v-card>
          <v-card-title>Add Terms / Agreement</v-card-title>
          <v-card-text>
            <v-form ref="termForm">
              <v-text-field
                required
                v-model="termName"
                label="Name"
                type="text"
                ref="termName"
                :rules="[(v) => !!v || '']"
              ></v-text-field>
              <!-- <v-text-field required v-model="termURL" label="URL" :readonly="termUrlReadonly" type="text" ref="termURL" :rules="[v => !!v || '']"></v-text-field> -->
              <el-upload
                class="upload-demo mb-2"
                ref="uploadPdf"
                drag
                action=""
                accept=".pdf"
                :auto-upload="false"
                :multiple="false"
                :on-change="uploadTermsPdf"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Drop PDF file here or <em>click to add</em></div>
              </el-upload>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="termModal = false">Close</v-btn>
            <v-btn dark tile depressed color="blue" @click="saveTerm">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END ADD TERMS/AGREEMENT DIALOG -->
      <!-- ADD CUSTOM REJECTION DIALOG -->
      <v-dialog v-model="rejectModal" width="400">
        <v-card>
          <v-card-title>Add reject document reason</v-card-title>
          <v-card-text>
            <v-form ref="rejectForm">
              <v-text-field
                required
                v-model="rejectName"
                label="Reason text"
                type="text"
                ref="rejectName"
                :rules="[(v) => !!v || '']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="rejectModal = false">Close</v-btn>
            <v-btn dark tile depressed color="blue" @click="saveReject">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END ADD CUSTOM REJECTION DIALOG -->
      <!-- ADD WEBHOOK DIALOG -->
      <v-dialog v-model="webhookModal" width="400">
        <v-card>
          <v-card-title>Add webhook</v-card-title>
          <v-card-text>
            <v-form ref="webhookForm">
              <v-select
                dense
                :items="webhookTypes"
                item-text="text"
                item-value="id"
                v-model="webhookTypeSelected"
                label="Webhook type"
              ></v-select>
              <v-text-field
                required
                v-model="webhookUrl"
                label="Url"
                type="url"
                ref="webhookUrl"
                :rules="[(v) => !!v || '']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text tile color="blue" @click="webhookModal = false">Close</v-btn>
            <v-btn dark tile depressed color="blue" @click="addWebhook">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END ADD WEBHOOK DIALOG -->
    </div>
  </DefaultLayout>
</template>

<script>
import uuidv4 from 'uuid/v4';
import { mapState } from 'vuex';
import {
  SAVE_ACCOUNT_SETTINGS,
  REFRESH_ACCOUNT_DATA,
  ADD_ACCOUNT_USER,
  UPDATE_ACCOUNT_USER_ROLES,
  REMOVE_ACCOUNT,
  REMOVE_ACCOUNT_USER,
  ADD_ACCOUNT_DECLINE_REASON,
  EDIT_ACCOUNT_DECLINE_REASON,
  REMOVE_ACCOUNT_DECLINE_REASON,
  ADD_ACCOUNT_TERM,
  REMOVE_ACCOUNT_TERM,
  ADD_REJECT_DOCUMENT_REASON,
  REMOVE_REJECT_DOCUMENT_REASON,
  ADD_WEBHOOK_ENDPOINT,
  REMOVE_WEBHOOK_ENDPOINT,
  UPLOAD_FILE,
  RESEND_CONFIRMATION_EMAIL,
  CREATE_SUMMARY_REQUEST,
  UPDATE_ACCOUNT_LOGO
} from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';
import JwtService from '@/common/jwt.service';

export default {
  name: 'organization-settings',
  components: {
    DefaultLayout
  },
  data() {
    return {
      pdfView: false,
      pdfData: null,
      pdfName: '',
      featureLimitedModal: false,
      featureLimitedText: '',
      featureLimitedDefaultText: 'To enable this feature, you need to upgrade your price plan.',
      orgSettingsTabs: 0,
      webhookFilter: null,
      webhookModal: false,
      webhookUrl: '',
      webhookTypes: [
        { id: 1, text: 'UserProfileRequestCreated' },
        { id: 2, text: 'UserProfileRequestStatusChanged' },
        { id: 3, text: 'UserProfileItemRequestStatusChanged' },
        { id: 4, text: 'UserProfileRequestDeleted' },
        { id: 5, text: 'UserProfileRequestCompleted' },
        { id: 6, text: 'UserProfileRequestClosed' },
        { id: 7, text: 'PVVerification' }
      ],
      webhookTypeSelected: 1,
      rejectName: '',
      rejectFilter: null,
      rejectModal: false,
      pageOptions: [10, 50, 100],
      perPage: 10,
      filter: null,
      filterReason: null,
      filterTerm: null,
      currentPage: 1,
      newAccountName: null,
      userHeaders: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Email', value: 'email', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left', sortable: false }
      ],
      userDataLoading: false,
      userSearch: '',
      userModal: false,
      declinedReasonsHeaders: [
        { text: 'Reason Name', value: 'declinedReason', align: 'left' },
        { text: 'Include In Email', value: 'includeInEmail', align: 'left' },
        { text: 'Description', value: 'description', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left', sortable: false }
      ],
      reasonModal: false,
      agreementsHeaders: [
        { text: 'Term/Agreement', value: 'name', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left', sortable: false }
      ],
      rejectHeaders: [
        { text: 'Reject reason', value: 'reason', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left', sortable: false }
      ],
      webhookHeaders: [
        { text: 'Type', value: 'typeString', align: 'left' },
        { text: 'Url', value: 'url', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left', sortable: false }
      ],
      termModal: false,
      accountId: null,
      orgId: null,
      accountName: null,
      isActive: false,
      allowPurgeWithoutDownload: false,
      enableCustomDeclinedReason: false,
      enableCustomRejectedDocumentReason: false,
      suppressStartRequestEmail: false,
      suppressFinishRequestEmail: false,
      allowOtherDeclinedReasons: false,
      rejectedDocumentAction: false,
      loading: false,
      userId: null,
      userModalTitle: 'Add User',
      userSelectedRoles: [],
      userFirstName: '',
      userLastName: '',
      userEmail: '',
      userEdit: false,
      declinedReasonTitle: 'Add New Declined Reason',
      currentReasonPage: 1,
      reasonEdit: false,
      reasonId: null,
      reasonName: '',
      reasonDescription: '',
      reasonIncludeInEmail: false,
      currentTermsPage: 1,
      termName: '',
      termURL: '',
      termUrlReadonly: false,
      privacyEmail: '',
      emailErrors: [],
      validateRequiredRule: (v) => !!v || 'This field is required',
      validateEmailRule: (v) => {
        const re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(v).toLowerCase()) || 'Please enter valid Email';
      },
      logo: [],
      createInProgress: false,
      logoRequirements: [
        {
          label: 'File Format:',
          description: 'The logo must be in one of the following formats: PNG, JPEG, or WEBP.'
        },
        { label: 'File Size:', description: 'The maximum file size allowed is 130KB.' },
        {
          label: 'Dimensions:',
          description:
            'The logo should have a minimum resolution of 300x300 pixels. For best results, a resolution of 1000x1000 pixels is recommended.'
        },
        {
          label: 'Background:',
          description:
            'The logo should have a transparent background (for PNG and WEBP files) or a solid white background (for JPEG files).'
        }
      ]
    };
  },
  computed: {
    ...mapState({ organization: (state) => state.organizations.userSelectedOrganization }),
    ...mapState({ signedInUser: (state) => state.auth.account }),
    ...mapState({ account: (state) => state.organizations.userSelectedAccount }),
    ...mapState({ systemRoles: (state) => state.auth.account.systemRoles }),
    ...mapState({
      limitations: (state) => state.organizations.userSelectedOrganization.limitations
    })
  },
  watch: {
    termModal(newVal) {
      if (!newVal) {
        this.termUrlReadonly = false;
      }
    },
    organization() {
      this.loadAccount();
    },
    account() {
      this.loadAccount();
    },
    featureLimitedModal(val) {
      if (!val) {
        this.featureLimitedText = '';
      }
    }
  },
  methods: {
    closeTermsPdfDialog() {
      this.pdfView = false;
      this.pdfData = null;
      this.pdfName = '';
    },
    async downloadAndSaveFile(url, name) {
      try {
        const fileData = await this.getFileData(url);
        this.saveFile(fileData);
        this.pdfView = true;
        this.pdfName = name;
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error downloading file. Please download again or contact support'
        });
      }
    },
    saveFile(dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: mimeString });
      // saveAs(blob, name);
      this.pdfData = URL.createObjectURL(blob);
    },

    // get file data 1
    async getFileData(url) {
      const responce = await fetch(url, {
        headers: {
          Authorization: 'Bearer ' + JwtService.getToken()
        }
      });
      var blob = await responce.blob();
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      await new Promise((resolve) => (reader.onload = () => resolve()));
      return reader.result;
    },

    getWebHookType(type) {
      return this.webhookTypes.find((x) => x.text === type).text;
    },
    async uploadTermsPdf(file, list) {
      if (!list.length) {
        return;
      }
      const newRequest = new FormData();
      newRequest.append('fileid', uuidv4());
      newRequest.append('Files', file.raw);
      try {
        const data = await this.$store.dispatch(UPLOAD_FILE, newRequest);
        this.termUrlReadonly = true;
        this.termURL = data.value.inlineURL;
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error uploading file. Please contact support@planetverify.com'
        });
        this.termUrlReadonly = false;
      }
    },
    loadAccount() {
      this.orgId = this.$store.state.organizations.userSelectedOrganization.id;
      this.accountId = this.$store.state.organizations.userSelectedAccount.accountId;
      this.accountName = this.$store.state.organizations.userSelectedAccount.name;
      this.isActive = this.$store.state.organizations.userSelectedAccount.active;
      this.allowPurgeWithoutDownload =
        this.$store.state.organizations.userSelectedAccount.allowPurgeWithoutDownload;
      this.enableCustomDeclinedReason =
        this.$store.state.organizations.userSelectedAccount.enableCustomDeclinedReason;
      this.allowOtherDeclinedReasons =
        this.$store.state.organizations.userSelectedAccount.allowOtherDeclinedReasons;
      this.rejectedDocumentAction =
        this.$store.state.organizations.userSelectedAccount.rejectedDocumentAction === 2
          ? true
          : false;
      this.enableCustomRejectedDocumentReason =
        this.$store.state.organizations.userSelectedAccount.enableCustomRejectDocumentReason;
      this.suppressStartRequestEmail =
        this.$store.state.organizations.userSelectedAccount.suppressStartRequestEmail;
      this.suppressFinishRequestEmail =
        this.$store.state.organizations.userSelectedAccount.suppressFinishRequestEmail;
    },
    async saveSettings() {
      if (!this.$refs.settingsForm.validate()) {
        return;
      }
      this.loading = true;
      const settings = {
        organizationId: this.orgId,
        accountId: this.accountId,
        name: this.accountName,
        active: this.isActive,
        allowPurgeWithoutDownload: this.allowPurgeWithoutDownload,
        enableCustomDeclinedReason: this.enableCustomDeclinedReason,
        allowOtherDeclinedReasons: this.allowOtherDeclinedReasons,
        rejectedDocumentAction: this.rejectedDocumentAction ? 2 : 0,
        enableCustomRejectDocumentReason: this.enableCustomRejectedDocumentReason,
        suppressStartRequestEmail: this.suppressStartRequestEmail,
        suppressFinishRequestEmail: this.suppressFinishRequestEmail
      };
      try {
        await this.$store.dispatch(SAVE_ACCOUNT_SETTINGS, settings);
        await this.$store.dispatch(REFRESH_ACCOUNT_DATA);
        this.loading = false;
        this.$notify({
          type: 'success',
          title: 'Success!',
          text: 'Settings Saved!'
        });
      } catch (err) {
        this.loading = false;
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error saving account. Please contact support@planetverify.com'
        });
      }
    },
    addUser() {
      if (this.account.users && this.account.users.length >= this.organization.maxUsersPerAccount) {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Sorry - you have reached the maximum number of users for this team. You can upgrade your account to add more users, just contact support@planetverify.com'
        });
        return;
      }
      this.userEdit = false;
      this.userModalTitle = 'Add User';
      this.userFirstName = '';
      this.userLastName = '';
      this.userEmail = '';
      this.userSelectedRoles = [
        'ProfileRequestAssigner',
        'ProfileRequestCanceller',
        'ProfileRequestCreator',
        'ProfileRequestCSVUploader',
        'ProfileRequestEditor',
        'ProfileRequestRejector',
        'ProfileRequestResender',
        'ProfileRequestSharer',
        'ProfileRequestViewer',
        'ProfileTemplatesViewer',
        'ReportingProfilesViewer',
        'SharedProfilesViewer',
        'SummaryRequestCreator',
        'VerificationsViewer'
      ];
      this.userModal = true;
    },
    editUser(user) {
      this.userEdit = true;
      this.userModalTitle = 'Edit User Roles';
      this.userId = user.userId;
      this.userFirstName = user.firstName;
      this.userLastName = user.lastName;
      this.userEmail = user.email;
      this.userSelectedRoles = user.roles;
      this.userModal = true;
    },
    removeUser(user) {
      if (confirm(`Remove ${user.firstName + ' ' + user.lastName} from Account?`)) {
        this.loading = true;
        var userToRemove = {
          organizationId: this.orgId,
          accountId: this.accountId,
          userId: user.userId
        };
        this.$store.dispatch(REMOVE_ACCOUNT_USER, userToRemove).then(
          () => {
            this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
              () => {
                this.loading = false;
                this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: 'User Removed!'
                });
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
      }
    },
    resendInvite(user) {
      if (confirm(`Resend invite to ${user.firstName + ' ' + user.lastName} ?`)) {
        this.loading = true;
        var userToRemove = {
          email: user.email,
          accountId: this.orgId
        };
        this.$store.dispatch(RESEND_CONFIRMATION_EMAIL, userToRemove).then(
          () => {
            this.loading = false;
            this.$notify({
              type: 'success',
              title: 'Success!',
              text: 'Invite sended!'
            });
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
      }
    },
    saveUser() {
      if (this.$refs.userForm.validate()) {
        if (this.userSelectedRoles.length != 0) {
          if (this.userEdit) {
            // EDIT USER
            var updateUserRoles = {
              organizationId: this.orgId,
              accountId: this.accountId,
              userId: this.userId,
              roles: this.userSelectedRoles,
              firstName: this.userFirstName,
              lastName: this.userLastName
            };
            this.$store.dispatch(UPDATE_ACCOUNT_USER_ROLES, updateUserRoles).then(
              () => {
                this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
                  () => {
                    this.loading = false;
                    this.$notify({
                      type: 'success',
                      title: 'Success!',
                      text: 'User Updated!'
                    });
                  },
                  () => {
                    this.loading = false;
                    this.$notify({
                      type: 'error',
                      title: 'Error!',
                      text: 'Something went wrong - please contact support@planetverify.com'
                    });
                  }
                );
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
            this.userModal = false;
          } else {
            // ADD NEW USER
            var newUser = {
              organizationId: this.orgId,
              accountId: this.accountId,
              email: this.userEmail,
              firstName: this.userFirstName,
              lastName: this.userLastName,
              roles: this.userSelectedRoles
            };
            this.$store.dispatch(ADD_ACCOUNT_USER, newUser).then(
              () => {
                this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
                  () => {
                    this.loading = false;
                    this.$notify({
                      type: 'success',
                      title: 'Success!',
                      text: 'User Added!'
                    });
                  },
                  () => {
                    this.loading = false;
                    this.$notify({
                      type: 'error',
                      title: 'Error!',
                      text: 'Something went wrong - please contact support@planetverify.com'
                    });
                  }
                );
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
            this.userModal = false;
          }
        } else {
          this.loading = false;
          this.$notify({
            type: 'error',
            title: 'Error!',
            text: 'Need select at least one user role'
          });
        }
      }
    },
    addReason() {
      this.reasonId = uuidv4();
      this.reasonName = '';
      this.reasonDescription = '';
      this.reasonIncludeInEmail = false;
      this.reasonEdit = false;
      this.reasonModal = true;
    },
    editReason(reason) {
      this.reasonId = reason.reasonId;
      this.reasonName = reason.declinedReason;
      this.reasonDescription = reason.description;
      this.reasonIncludeInEmail = reason.includeInEmail;
      this.reasonEdit = true;
      this.reasonModal = true;
    },
    removeReason(reason) {
      if (confirm('Remove Decline Reason?')) {
        this.loading = true;
        var removeReason = {
          organizationId: this.orgId,
          accountId: this.accountId,
          id: reason.reasonId,
          name: reason.declinedReason,
          description: reason.description,
          includeInEmail: reason.includeInEmail
        };
        this.$store.dispatch(REMOVE_ACCOUNT_DECLINE_REASON, removeReason).then(
          () => {
            this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
              () => {
                this.loading = false;
                this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: 'Decline Reason Removed!'
                });
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
      }
    },
    saveDeclinedReason() {
      if (this.$refs.reasonForm.validate()) {
        if (this.reasonEdit) {
          // EDIT DECLINED REASON
          var editReason = {
            organizationId: this.orgId,
            accountId: this.accountId,
            id: this.reasonId,
            name: this.reasonName,
            description: this.reasonDescription,
            includeInEmail: this.reasonIncludeInEmail
          };
          this.$store.dispatch(EDIT_ACCOUNT_DECLINE_REASON, editReason).then(
            () => {
              this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
                () => {
                  this.loading = false;
                  this.$notify({
                    type: 'success',
                    title: 'Success!',
                    text: 'Decline Reason Added!'
                  });
                },
                () => {
                  this.loading = false;
                  this.$notify({
                    type: 'error',
                    title: 'Error!',
                    text: 'Something went wrong - please contact support@planetverify.com'
                  });
                }
              );
            },
            () => {
              this.loading = false;
              this.$notify({
                type: 'error',
                title: 'Error!',
                text: 'Something went wrong - please contact support@planetverify.com'
              });
            }
          );
          this.reasonModal = false;
        } else {
          // ADD DECLINED REASON
          var newReason = {
            organizationId: this.orgId,
            accountId: this.accountId,
            id: this.reasonId,
            name: this.reasonName,
            description: this.reasonDescription,
            includeInEmail: this.reasonIncludeInEmail
          };
          this.$store.dispatch(ADD_ACCOUNT_DECLINE_REASON, newReason).then(
            () => {
              this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
                () => {
                  this.loading = false;
                  this.$notify({
                    type: 'success',
                    title: 'Success!',
                    text: 'Decline Reason Added!'
                  });
                },
                () => {
                  this.loading = false;
                  this.$notify({
                    type: 'error',
                    title: 'Error!',
                    text: 'Something went wrong - please contact support@planetverify.com'
                  });
                }
              );
            },
            () => {
              this.loading = false;
              this.$notify({
                type: 'error',
                title: 'Error!',
                text: 'Something went wrong - please contact support@planetverify.com'
              });
            }
          );
          this.reasonModal = false;
        }
      }
    },
    addTerm() {
      this.termName = '';
      this.termURL = '';
      this.termModal = true;
    },
    addReject() {
      this.rejectName = '';
      this.rejectModal = true;
    },
    removeTerm(term) {
      if (confirm('Remove Term?')) {
        this.loading = true;
        var removeTerm = {
          organizationId: this.orgId,
          accountId: this.accountId,
          name: term.name,
          url: term.url
        };
        this.$store.dispatch(REMOVE_ACCOUNT_TERM, removeTerm).then(
          () => {
            this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
              () => {
                this.loading = false;
                this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: 'Term Removed!'
                });
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
      }
    },
    saveTerm() {
      if (this.$refs.termForm.validate()) {
        var newTerm = {
          organizationId: this.orgId,
          accountId: this.accountId,
          name: this.termName,
          url: this.termURL
        };

        this.$store.dispatch(ADD_ACCOUNT_TERM, newTerm).then(
          () => {
            this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
              () => {
                this.loading = false;
                this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: 'Term Added!'
                });
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
        this.termModal = false;
        this.$refs.uploadPdf.clearFiles();
        this.termName = '';
        this.$nextTick(() => {
          this.$refs.termForm.resetValidation();
        });
      }
    },
    saveReject() {
      if (this.$refs.rejectForm.validate()) {
        var newTerm = {
          organizationId: this.orgId,
          accountId: this.accountId,
          id: uuidv4(),
          reason: this.rejectName
        };
        this.$store.dispatch(ADD_REJECT_DOCUMENT_REASON, newTerm).then(
          () => {
            this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
              () => {
                this.loading = false;
                this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: 'Reject reason Added!'
                });
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
        this.rejectModal = false;
      }
    },
    removeReject(item) {
      if (confirm('Delete reject reason?')) {
        var term = {
          organizationId: this.orgId,
          accountId: this.accountId,
          id: item.reasonId
        };
        this.$store.dispatch(REMOVE_REJECT_DOCUMENT_REASON, term).then(
          () => {
            this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
              () => {
                this.loading = false;
                this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: 'Reject reason removed!'
                });
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
      }
    },
    removeAccount() {
      if (confirm('Delete Account?')) {
        this.loading = true;
        var removeAccount = {
          organizationId: this.orgId,
          accountId: this.accountId
        };
        this.$store.dispatch(REMOVE_ACCOUNT, removeAccount).then(
          () => {
            this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
              () => {
                this.loading = false;
                this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: 'Account Removed!'
                });
                this.$parent.$parent.$parent.switchAccount(
                  this.$store.state.organizations.userSelectedOrganization.accounts[0].id
                );
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
      }
    },
    addWebhook() {
      if (this.$refs.webhookForm.validate()) {
        var webhook = {
          organizationId: this.orgId,
          accountId: this.accountId,
          id: uuidv4(),
          type: this.webhookTypeSelected,
          url: this.webhookUrl
        };
        this.$store.dispatch(ADD_WEBHOOK_ENDPOINT, webhook).then(
          () => {
            this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
              () => {
                this.loading = false;
                this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: 'Webhook Added!'
                });
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
        this.webhookModal = false;
      }
    },
    removeWebhook(item) {
      if (confirm('Delete Webhook?')) {
        this.loading = true;
        var removeWebhook = {
          organizationId: this.orgId,
          accountId: this.accountId,
          id: item.endpointId
        };
        this.$store.dispatch(REMOVE_WEBHOOK_ENDPOINT, removeWebhook).then(
          () => {
            this.$store.dispatch(REFRESH_ACCOUNT_DATA).then(
              () => {
                this.loading = false;
                this.$notify({
                  type: 'success',
                  title: 'Success!',
                  text: 'Webhook Removed!'
                });
              },
              () => {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'Something went wrong - please contact support@planetverify.com'
                });
              }
            );
          },
          () => {
            this.loading = false;
            this.$notify({
              type: 'error',
              title: 'Error!',
              text: 'Something went wrong - please contact support@planetverify.com'
            });
          }
        );
      }
    },
    createPrivacyAudit() {
      if (this.$refs.privacyForm.validate()) {
        const request = {
          requestedEmail: this.privacyEmail,
          requesterUserId: this.signedInUser.loggedInUserId,
          organizationId: this.organization.id
        };
        this.$store.dispatch(CREATE_SUMMARY_REQUEST, request).then(
          () => {
            this.$notify({
              type: 'success',
              title: 'Success',
              text: 'Privacy audit requested'
            });
          },
          () => {
            this.$notify({
              type: 'error',
              title: 'Error',
              text: "User doesn't exist or something went wrong"
            });
          }
        );
        this.privacyEmail = '';
        this.$refs.privacyForm.reset();
        this.privacyModal = false;
      }
    },
    async addLogo() {
      this.createInProgress = true;

      const formData = new FormData();
      this.logo.forEach((f) => {
        formData.append('files', f);
      });
      formData.append('OrganizationId', this.orgId);
      formData.append('AccountId', this.accountId);

      try {
        await this.$store.dispatch(UPDATE_ACCOUNT_LOGO, formData);
        await this.$store.dispatch(REFRESH_ACCOUNT_DATA);
        this.createInProgress = false;
      } catch (err) {
        this.createInProgress = false;
      }
    }
  },
  mounted() {
    this.loadAccount();
  }
};
</script>
<style>
.requirements-list {
  list-style-type: none;
  padding: 0;
}
</style>
